import React, {useEffect, useRef} from 'react';
import {NavLink} from 'react-router-dom';
import {useTranslate} from 'react-redux-multilingual';
import {TbPhone, TbX} from 'react-icons/tb';
import LanguageSwitchBlock from './language-switch';
import contacts from '../../../../constants/contacts';

// Slide-in navigation for < 1100px. Uses the same menu.json items as the desktop nav.
function MobileNav({id, open, menu, onClose, onScheduleVisit}) {
    const t = useTranslate();
    const closeRef = useRef(null);

    useEffect(() => {
        if (!open) {
            return undefined;
        }
        const previous = document.activeElement;
        document.body.style.overflow = 'hidden';
        if (closeRef.current) {
            closeRef.current.focus();
        }
        const onKey = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = '';
            document.removeEventListener('keydown', onKey);
            if (previous && previous.focus) {
                previous.focus();
            }
        };
    }, [open, onClose]);

    const renderItem = (item, key, isChild) => (
        <li key={key}>
            <NavLink to={`${process.env.PUBLIC_URL}${item.link}`} exact={isChild}
                     className={isChild ? 'cpr-drawer__sublink' : 'cpr-drawer__link'}
                     activeClassName="is-active" onClick={onClose}>
                {item.link === '/live' && <span className="cpr-live-dot" aria-hidden="true"/>}
                {item.name}
            </NavLink>
            {item.children.length > 0 &&
                <ul className="cpr-drawer__sub">
                    {item.children.map((child, childKey) => renderItem(child, childKey, true))}
                </ul>
            }
        </li>
    );

    return (
        <div className={`cpr-drawer${open ? ' is-open' : ''}`} aria-hidden={!open}>
            <div className="cpr-drawer__overlay" onClick={onClose}/>
            <div id={id} className="cpr-drawer__panel" role="dialog" aria-modal="true" aria-label={t('menu')}>
                <div className="cpr-drawer__top">
                    <LanguageSwitchBlock block/>
                    <button ref={closeRef} type="button" className="cpr-header__menu-btn" onClick={onClose}
                            tabIndex={open ? 0 : -1}>
                        <TbX aria-hidden="true"/>
                        <span className="cpr-visually-hidden">{t('close')}</span>
                    </button>
                </div>
                <nav aria-label="Main">
                    <ul className="cpr-drawer__list">
                        {menu.map((item, key) => renderItem(item, key, false))}
                    </ul>
                </nav>
                <div className="cpr-drawer__bottom">
                    <button type="button" className="cpr-btn cpr-btn--primary cpr-btn--block"
                            onClick={onScheduleVisit} tabIndex={open ? 0 : -1}>
                        {t('schedule_a_visit')}
                    </button>
                    <a className="cpr-btn cpr-btn--secondary cpr-btn--block cpr-num" href={contacts.phone.href}
                       tabIndex={open ? 0 : -1}>
                        <TbPhone aria-hidden="true"/>{contacts.phone.display}
                    </a>
                </div>
            </div>
        </div>
    );
}

export default MobileNav;
